import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface CallOwnershipState {
  ownerId: string | null;
  ownerName: string | null;
  isOwner: boolean;
  claimedAt: number | null;
  updatedAt: number | null;
}

const initialState: CallOwnershipState = {
  ownerId: null,
  ownerName: null,
  isOwner: false,
  claimedAt: null,
  updatedAt: null,
};

const callOwnershipSlice = createSlice({
  name: 'callOwnership',
  initialState,
  reducers: {
    setCallOwnership: (state, action: PayloadAction<{
      ownerId: string | null;
      ownerName?: string | null;
      isOwner: boolean;
      claimedAt?: number | null;
      updatedAt?: number;
    }>) => {
      state.ownerId = action.payload.ownerId;
      state.ownerName = action.payload.ownerName ?? state.ownerName;
      state.isOwner = action.payload.isOwner;
      state.claimedAt = action.payload.claimedAt ?? state.claimedAt;
      state.updatedAt = action.payload.updatedAt ?? Date.now();
    },
    /**
     * Hydrate call ownership from persisted storage (localStorage or Supabase)
     * Used by useCallOwnershipSync to restore state on mount
     */
    hydrateCallOwnership: (state, action: PayloadAction<{
      ownerId: string | null;
      ownerName: string | null;
      isOwner: boolean;
      claimedAt: number | null;
      updatedAt?: number;
    }>) => {
      state.ownerId = action.payload.ownerId;
      state.ownerName = action.payload.ownerName;
      state.isOwner = action.payload.isOwner;
      state.claimedAt = action.payload.claimedAt;
      state.updatedAt = action.payload.updatedAt ?? Date.now();
    },
    clearCallOwnership: () => initialState,
  },
});

export const { setCallOwnership, hydrateCallOwnership, clearCallOwnership } = callOwnershipSlice.actions;
export default callOwnershipSlice.reducer;
